<template>
  <div v-if="belongsCompany">
    <Breadcrumb />
    <v-card elevation="2" style="min-height: 50vh">
      <v-layout row wrap class="mt-4 px-1 py-2 justify-space-around">

        <v-flex xs12 md12>
          <ShowAdvancePayment :current_period="current_period" :advance_payments="advance_payments" @advance_payment_added="handleAdvancePaymentAdded"/>
        </v-flex>
        
      </v-layout>
    </v-card>
  </div>
  <div v-else>
  </div>
</template>
<script>
import { mapActions, mapState} from "vuex";
import Swal from "sweetalert2"
import Breadcrumb from "@/components/General/Breadcrumb";
import ShowAdvancePayment from "../../components/AdvancePayments/ShowAdvancePayment.vue";

export default {
  components: {
    Breadcrumb,
    ShowAdvancePayment
  },
  data() {
    return {
      advance_payments: [],
      companies: [],
      current_period: ''
    };
  },
  methods: {
    ...mapActions("advance_payments", ["fetchAdvancePayments", "fetchCompanies", "fetchCurrentPeriod"]),
    async getAdvancePayments() {
      const res = await this.fetchAdvancePayments();
      if (res !== undefined) {
        this.advance_payments = res;
      }
    },
    async getCompanies() {
      const res = await this.fetchCompanies();
      this.companies = res;
    },
    async getCurrentPeriod() {
      const res = await this.fetchCurrentPeriod();
      this.current_period = res;
    },
    handleAdvancePaymentAdded(advance_payment) {
      advance_payment.hidden = true;
      if(advance_payment.id){
        const existingAdvance = this.advance_payments.find(item => item.id === advance_payment.id);
        if (existingAdvance) {
          Object.assign(existingAdvance, advance_payment);
        }else{
          this.advance_payments.unshift(advance_payment);
        }
      }else{
        this.advance_payments.unshift(advance_payment);
      }
    }
  },
  computed: {
    ...mapState("user", ["current_user"]),
    belongsCompany() {
      return this.companies.includes(this.current_user.company);
    }
  },
  created() {
    this.getAdvancePayments();
    this.getCompanies();
    this.getCurrentPeriod();
  },
  mounted() {},
};
</script>
<style lang="css"></style>
